// extracted by mini-css-extract-plugin
export default {"rating":"Hy-z","numberOfStars":"Iy-z","count":"Jy-z","barGraphSpacing":"Ky-z","barGraph":"Ly-z"};